/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import {
  countryCodeIndia,
  userDrawerFormKey,
  userDrawerFormLabel
} from '../../../pages/setting/utils/User Manager/Constants/commonConst';
import base64Encode from '../../../shared/base64encoder';
import useUserStore from '../../../store/userStore/userStore';

export const userManagementUpload = async (file: any): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const res = await axios.request({
      method: CRUDMethods.POST,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.uploadUserManagerFile}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        file: await base64Encode(file).then((result) => {
          return result;
        })
      }
    });
    const formattedUsers = res?.data?.data?.map((user: any, index: number) => ({
      id: Date.now() + index,
      [userDrawerFormKey.FIRST_NAME]: user[userDrawerFormLabel.FIRST_NAME],
      [userDrawerFormKey.LAST_NAME]: user[userDrawerFormLabel.LAST_NAME],
      [userDrawerFormKey.EMAIL]: user[userDrawerFormLabel.EMAIL],
      [userDrawerFormKey.MOBILE]: `${countryCodeIndia}${
        user[userDrawerFormLabel.MOBILE]
      }`
    }));

    return formattedUsers;
  } catch (err) {
    return (err as any)?.response?.data;
  }
};
